module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-45.2b4658eb.png";